import styled from 'styled-components';
import Stack from '@karma/components/Stack';
import { getColor } from '@karma/components/colors';
import { Checkbox } from '@karma/components';

export const Overlay = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  padding: 8px;
  width: 100%;
  height: 100%;
  border-radius: 10px 10px 0 0;
  z-index: 1;

  background: ${({ isMouseover }) => (isMouseover ? `${getColor('neutral6')}30` : 'transparent')};
`;

export const OverlayTopGroupRight = styled(Stack)`
  position: absolute;
  right: 8px;
  top: 8px;
`;

export const OverlayBottom = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  color: ${getColor('primary1')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px 0px 10px 10px;
  background: rgba(249, 249, 249, 0.2);
  backdrop-filter: blur(10px);
`;

export const StyledCheckbox = styled(Checkbox)`
  position: absolute;
  left: 8px;
  top: 8px;
`;
